import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ProgressBarSection } from "./component/ProgressBarSection";
import { AdminSection } from "./component/AdminSection";
import { SignIn } from "./component/SignIn";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ProgressBarSection />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/admin" element={<AdminSection />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
